import { render, staticRenderFns } from "./lack_handle_type.vue?vue&type=template&id=ef3cdc6a&scoped=true"
import script from "./lack_handle_type.vue?vue&type=script&lang=js"
export * from "./lack_handle_type.vue?vue&type=script&lang=js"
import style0 from "./lack_handle_type.vue?vue&type=style&index=0&id=ef3cdc6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3cdc6a",
  null
  
)

export default component.exports